import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"
import React, { Component } from "react"
import DeprecatedUserSelect from "../../common/user/selection.component.jsx"
import ActionButton from "../button/actionbutton.component.jsx"
import Icon from "../icon/icon.component.jsx"
const uuidv4 = require("uuid/v4")

class InlineEditUser extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            seller: this.props.value,
            sellerId: this.props.userId,
            endPoint: this.props.endPoint || "",
            field: this.props.field || "",
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
            selectedSeller: this.props.selectedSeller
        }
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
    }

    componentDidUpdate(prevProps, prevState) {
        const { value, sellerId, endPoint, field } = this.props
        let updatedState = {}
        if (value !== prevProps.value) {
            updatedState.seller = value
        }
        if (sellerId !== prevProps.sellerId) {
            updatedState.sellerId = sellerId
        }
        if (endPoint !== prevProps.endPoint) {
            updatedState.endPoint = endPoint
        }
        if (field !== prevProps.field) {
            updatedState.field = field
        }

        if (Object.keys(updatedState).length !== 0) {
            this.setState(updatedState)
        }
    }

    componentDidMount() {
        if (this.state.sellerId && !this.state.seller) {
            AppContext.getApiClient()
                .get("/public-users/" + this.state.sellerId)
                .then(r => {
                    if (!r.error) {
                        this.setState({
                            seller: r.attributes.name
                        })
                    }
                })
        }
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        })
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        })
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleUserSelectChange(userId, sellerName) {
        this.setState({
            sellerId: userId,
            selectedSeller: sellerName
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true
        })
        AppContext.getApiClient()
            .patch(this.state.endPoint, {
                [this.state.field]: this.state.sellerId
            })
            .then(r => {
                this.setState(
                    {
                        seller: this.state.selectedSeller,
                        editMode: false,
                        isLoading: false,
                        success: !r.error
                    },
                    () => {
                        setTimeout(() => {
                            this.setState({
                                success: false
                            })
                        }, 1500)
                    }
                )
                this.onSave(this.state)
            })
    }

    render() {
        let seller = this.state.seller || "-"
        if (this.state.editable) {
            let link = (
                <a
                    href={"#"}
                    onClick={this.triggerEdit}
                    onMouseEnter={this.onMouseEnterHandler}
                    onMouseLeave={this.onMouseLeaveHandler}
                >
                    {seller}{" "}
                    {!this.state.success ? (
                        <Icon value={"pencil-alt"} className={"ml-1 " + (!this.state.hover ? "text-gray" : "")} />
                    ) : (
                        <Icon value={"check"} className={"ml-1 " + (!this.state.hover ? "text-success short-fade-out" : "")} />
                    )}
                </a>
            )
            seller = (
                <span>
                    {link}
                    <div className={"dropdown-menu p-4 " + (this.state.editMode ? "show" : "")} style={{ width: "350px" }}>
                        <div className="w-100 m-0">
                            <DeprecatedUserSelect value={this.state.sellerId} onChange={this.handleUserSelectChange} />
                        </div>
                        <p className="m-0 pt-2">
                            <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                                <Icon value={"arrow-left"} />
                            </button>
                            <ActionButton
                                className="btn btn-sm btn-outline-primary ml-2"
                                onClick={this.save}
                                isLoading={this.state.isLoading}
                            >
                                <Icon value={"save"} />
                            </ActionButton>
                        </p>
                    </div>
                </span>
            )
        }
        return seller
    }
}

export default InlineEditUser



// WEBPACK FOOTER //
// ./src/common/inline-edit/user.component.jsx